import { styled, Breakpoints } from '@vw-marketing/us-components';

export const StyledTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.size.static250};
  padding: 0 ${({ theme }) => theme.size.grid002};
`;

export const StyledCTA = styled.div`
  color: "#001e50";
`;
